import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/request.js";
import "@ui5/webcomponents-icons/dist/cart-4.js";
import "@ui5/webcomponents-icons/dist/official-service.js";
import "@ui5/webcomponents-icons/dist/inventory.js";
import "@ui5/webcomponents-icons/dist/wrench.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { procPermissions, procSettingsGroup } from "./permissions";

/** Procurement entries of the navigation registry (group `proc`, docs/contracts/procurement.md). */
export const procNavigation: readonly NavigationEntry[] = [
  {
    key: "proc.requests",
    labelKey: "nav.procRequests",
    icon: "request",
    path: "/proc/requests",
    permission: procPermissions.requestView,
  },
  {
    key: "proc.sourcing",
    labelKey: "nav.procSourcing",
    icon: "cart-4",
    path: "/proc/sourcing",
    permission: procPermissions.requestConvert,
  },
  {
    key: "proc.tenders",
    labelKey: "nav.procTenders",
    icon: "official-service",
    path: "/proc/tenders",
    permission: procPermissions.tenderView,
  },
  {
    key: "proc.refills",
    labelKey: "nav.procRefills",
    icon: "inventory",
    path: "/proc/refills",
    permission: procPermissions.refillView,
  },
  {
    key: "proc.setup",
    labelKey: "nav.procSetup",
    icon: "wrench",
    path: "/proc/setup",
    permission: procPermissions.serviceView,
  },
  {
    key: "proc.settings",
    labelKey: "nav.procSettings",
    icon: "settings",
    path: `/platform/settings/${procSettingsGroup}`,
    permission: procPermissions.settingsView,
  },
];
